import {
  put, takeLatest, takeEvery, all,
} from 'redux-saga/effects';
import { notification } from 'antd';
import DocConfigActions, { docConfigActionTypes } from '@Actions/docConfigActions';
import TrackerActions from '@Actions/trackerActions';
import DocConfigServices from '@Services/docConfigServices';

/**
 * @param action
 */
function* _getDocConfig(action) {
  const {
    tenantId, entityName,
  } = action;
  try {
    yield put(DocConfigActions.getDocConfigLoading(true, entityName));
    const docConfig = yield DocConfigServices.getDocConfig(tenantId, entityName);
    yield put(DocConfigActions.getDocConfigSuccess(docConfig, entityName));
    if (action?.callback) action.callback(docConfig?.data);
    yield put(DocConfigActions.getDocConfigLoading(false, entityName));
  } catch (error) {
    yield put(DocConfigActions.getDocConfigLoading(false, entityName));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(docConfigActionTypes.GET_DOC_CONFIG.ERROR, error));
  }
}

/**
 *
 */
function* getDocConfig() {
  yield takeEvery(docConfigActionTypes.GET_DOC_CONFIG.REQUEST, _getDocConfig);
}

/**
 *   updateSTDocConfig
 */

function* _updateDocConfig(action) {
  try {
    yield put(DocConfigActions.updateDocConfigLoading(true));
    const { payload } = action;
    const docConfig = yield DocConfigServices.updateDocConfig(payload);
    if (docConfig.success) {
      notification.open({
        type: 'success',
        message: docConfig?.message,
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) action.callback();
      yield put(DocConfigActions.updateDocConfigLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: docConfig?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(DocConfigActions.updateDocConfigLoading(false));
    }
  } catch (error) {
    yield put(DocConfigActions.updateDocConfigLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(docConfigActionTypes.UPDATE_DOC_CONFIG.ERROR, error));
  }
}

/**
 *
 *
 */
function* updateDocConfig() {
  yield takeLatest(docConfigActionTypes.UPDATE_DOC_CONFIG.REQUEST, _updateDocConfig);
}

export default function* docConfigSaga() {
  yield all([
    getDocConfig(),
    updateDocConfig(),
  ]);
}
